import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CapabilityGuard } from '@tenant/capabilities';
import { AuthCodeGuard } from '@tenant/core';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { ApplicationsPaymentComponent } from './applications-payment/applications-payment.component';
import { DashboardComponent } from './dashboard/dashboard.component';

const ROUTES: Routes = [
  // {
  //   path: 'dashboard',
  //   canActivate: [AuthCodeGuard],
  //   component: DashboardComponent,
  //   data: {
  //     title: 'dashboard',
  //   },
  // },
  // {
  //   path: 'contacts',
  //   canActivate: [AuthCodeGuard],
  //   loadChildren: () =>
  //     import('./contacts/contacts.module').then((m) => m.ContactsModule),
  // },
  {
    path: 'work-queue',
    canActivate: [AuthCodeGuard],
    loadChildren: () =>
      import('./work-queue/work-queue.module').then((m) => m.WorkQueueModule),
  },
  {
    path: 'applications-payment',
    component: ApplicationsPaymentComponent,
  },
  {
    path: 'deal',
    canActivate: [AuthCodeGuard],
    loadChildren: () => import('./deal/deal.module').then((m) => m.DealModule),
  },
  {
    // Permission denials (CapabilityGuard and the NgxPermissionsGuard
    // `redirectTo` targets) land on '/not-found' — the FGR-Hub-style 404 page,
    // authenticated but otherwise ungated, so a denial can never loop. The
    // '**' wildcard renders the same page in place. NOTE: 'deal' is the ''
    // fallback and 'landlords' has no capability in the registry yet — both
    // left ungated.
    path: 'tasks',
    data: {
      title: 'My Tasks',
      capability: 'canViewMyTasks',
    },
    canActivate: [AuthCodeGuard, CapabilityGuard],
    loadChildren: () =>
      import('./my-tasks/my-tasks.module').then((m) => m.MyTasksModule),
  },
  {
    path: 'reports',
    canActivate: [AuthCodeGuard],
    loadChildren: () =>
      import('./reports/reports.module').then((m) => m.ReportsModule),
  },
  {
    path: 'landlords',
    canActivate: [AuthCodeGuard],
    loadChildren: () =>
      import('./landlords/landlords.module').then((m) => m.LandlordsModule),
  },
  {
    path: 'not-found',
    canActivate: [AuthCodeGuard],
    component: PageNotFoundComponent,
    data: { title: 'Page Not Found' },
  },
  { path: '', pathMatch: 'full', redirectTo: 'deal' },
  // No route matched: render the 404 page in place (keeps the typed URL),
  // mirroring the FGR Hub's wildcard -> account-404 route.
  {
    path: '**',
    canActivate: [AuthCodeGuard],
    component: PageNotFoundComponent,
    data: { title: 'Page Not Found' },
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(ROUTES, {
      relativeLinkResolution: 'legacy',
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRouterModule {}
